export default __webpack_public_path__ + "static/media/Hero.0bfe1794.png";